<div id="uploadModal" class="modal fade">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header align-items-center">
				<h6 class="mb-0 text-uppercase">Upload file</h6>
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="center">
					<ngx-file-drop
						dropZoneLabel="Drop files here"
						accept=".xls, .xlsx"
						(onFileDrop)="dropped($event)"
						dropZoneClassName="drop-area"
						contentClassName="drop-area-content"
					>
						<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
							<div class="d-flex justify-content-center flex-column align-items-center py-4">
								<p>Drop files here</p>
								<p>or</p>
								<button mat-stroked-button type="button" (click)="openFileSelector()" class="d-block">
									Select files
								</button>
							</div>
						</ng-template>
					</ngx-file-drop>
					<div class="upload-table">
						<table class="table">
							<tbody class="upload-name-style">
								<tr *ngFor="let item of files; let i = index">
									<td>
										Uploaded:
										<strong>{{ item.relativePath }}</strong>
									</td>
								</tr>
								<tr *ngIf="uploadError" class="text-error">
									<td>File must have less than {{ this.maxRows }} rows</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- [disabled]="!fileReady" -->
					<div class="d-flex justify-content-center">
						<button mat-stroked-button type="button" (click)="uploadFile()" class="d-block my-0">
							Confirm
						</button>
						<mat-spinner *ngIf="isFileSelected && !fileReady" class="m-0 ml-2"></mat-spinner>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
